import { Switch, Case, Default } from 'react-logic-switch';
import PropTypes from 'prop-types';
import Icon from '../icon';
import RecommendationsContainer from '../articleList/containers/recommendationsListContainer';

const RecommendationsLoader = ({ loadedState }) => (
  <>
    <div className="u-margin-m-bottom">Recommended Articles</div>
    <Switch arg={loadedState}>
      <Case match="loading">
        <div style={{ display: 'flex', justifyContent: 'center' }}><Icon.Spinner height={48} width={39.75} /></div>
      </Case>
      <Case match="failed">
        <span className="u-text--">No articles found</span>
      </Case>
      <Default>
        <RecommendationsContainer />
      </Default>
    </Switch>
  </>
);

RecommendationsLoader.propTypes = {
  loadedState: PropTypes.oneOf(['failed', 'success', 'loading']).isRequired,
};

export default RecommendationsLoader;
